import { Component, OnInit } from '@angular/core';
import { LogService } from '../_shared/log.service';

@Component({
  selector: 'app-associate',
  templateUrl: './associate.component.html',
  styleUrls: ['./associate.component.less']
})
export class AssociateComponent implements OnInit {

  constructor(private eventService: LogService) { }


  public routeVal = '';
  receiveVal($event){
    this.routeVal = $event;
  }

  public newData = ''
  ngOnInit() {
    this.eventService.on<string>().subscribe(
      data => {
        this.newData = data
        this.routeVal = this.newData
        console.log(this.newData +"final")
      }
    )
  }

}